module.exports = __webpack_public_path__ + "img/skinxs-logo-medium.4c207dc9.svg";